// src/cert/ce.js
import React from 'react';
import ApplyForm from '../components/ApplyForm';
import './CertPage.css';

const CE = () => {
    return (
        <div className="cert-page">
            <div className="cert-header">
                <h1>CE Marking प्रमाणन</h1>
                <p>युरोपियन अनुरूपता चिन्ह (Conformité Européenne)</p>
            </div>

            <div className="cert-content">
                <section>
                    <h2>CE Marking म्हणजे काय?</h2>
                    <p>
                        CE marking services has existed in its present form since 1993. CE stands for Conformite Europeenne, which in practice means that it conforms to European directives. CE marking of a product means that it complies with the legal requirements placed on the product within the EEA and therefore can be sold there. The manufacturer or their authorised representative gives the product its CE marking and is liable for ensuring that the product complies with the requirements of the directives. The primary purpose of CE marking is to facilitate free trade of goods within the EU. A secondary purpose is the harmonisation of laws concerning safety, health and the environment within the EU.

                        CE marking is mandatory

                        CE marking is mandatory for allowing access to the European Union. This is dictated by a number of directives and covers most products For electrical and electronic products the below 10 directives are the most commonly used.

                        Low Voltage Directive (LVD) 2014/35/EU

                        EMC Directive 2014/30/EU

                        Radio Equipment Directive (RED) 2014/53/EU

                        Restriction of the use of certain hazardous substances (RoHS), Directive 2011/65/EU

                        Energy related Products Directive (ErP) 2009/125/EC

                        Maritime Equipment Directive (MED) 2014/90/EU

                        Equipment and protective systems intended for use in potentially explosive atmospheres (ATEX) 2014/34/EU

                        Medical Device Regulation (MDR) 2017/745/EU

                        Construction Products Regulation 305/2011/EU (CPR)

                        Machinery Directive (MD) 2006/42/EC
                    </p>
                </section>

                <section>
                    <h2>प्रमुख फायदे</h2>
                    <ul>
                        <li>EU (30+ देश) मध्ये उत्पादन विक्री कायदेशीर होते</li>
                        <li>सुरक्षा, EMC, RoHS, LVD सारख्या निर्देशांचे अनुपालन</li>
                        <li>उत्पादनाची विश्वासार्हता आणि बाजार मान्यता वाढते</li>
                        <li>दंड, परतावा आणि बाजारातून काढून टाकण्यापासून वाचतो</li>
                        <li>तांत्रिक दस्तऐवज, DoC, EU प्रतिनिधी आवश्यकता पूर्ण होतात</li>
                    </ul>
                </section>

                <section className="apply-section">
                    <h2>CE Marking साठी अर्ज करा</h2>
                    <ApplyForm certification="CE Marking" />
                </section>
            </div>
        </div>
    );
};

export default CE;